import { getOrderBook, getIpoList, getCmotsIpo, getPlaceModifyBid } from "../../apis";
import { BUSINESS_LAYER_RESPONSE, CATEGORY_NAME, IPO_TYPE, MAX_LOT, MAX_LOT_VALUE, MIN_LOT, MIN_LOT_VALUE, QUICK_BID } from "../../utils/global_variables";
import moment from "moment";

/**KAMESH */

function formatToCustomDate(inputDate) {
  
    const possibleFormats = ['YYYY-DD-MM HH:mm:ss','DD-MM-YYYY HH:mm:ss'];
  
    const parsedDate = moment(inputDate, possibleFormats, true);
  
    if (parsedDate.isValid()) {
      return parsedDate.format("DD MMM'YYYY");
    } else {
      return 'Invalid date';
    }
  }
async function _getOrderBookDetails(objOrderBookPayload) {

    // this function is used to get orderbook details of ipo here,manipualating some data based on requiremnets
    //objOrderBookPayload ==> it is objectpayload which contain applicationNo,currentDate,endDate,ipocode, offername ,startdate



    try {
        const objResp = await getOrderBook(objOrderBookPayload);
        const OrderBookslist = objResp?.data?.data?.data;
        const orderbookQuantity = (data, ele) => {
            var result = "";
            const quantity = data?.map((val) => {
                return val.quantity;
            });
            result = quantity?.map((val) => {
                return `${ele.allocatedQty}/${val}`;
            });
            return result.toString();

        };
        const data = OrderBookslist?.map((ele, i) => ({
            exchangeName: ele?.exchangeName,
            issueType: ele?.issueType,
            ipoType: ele?.IPOType,
            id: ele.clientId,
            expandCell: "",
            date: formatToCustomDate(ele.date),
            title: ele.ipoName,
            status: ele.bidStatusName,
            application_no: parseInt(ele.applicationNo),
            qty: orderbookQuantity(ele.bids, ele)
            ,
            highest_bi: `₹${ele?.bids?.reduce((max, bid) => {
                return parseFloat(bid?.price) > parseFloat(max?.price) ? bid : max;
            })?.price}`
            ,
            bid_placed: parseInt(ele?.bids?.length),
            listing: ele.exchangeName,
            bids: ele.bids,
            transactionNo: ele.transactionNo,
            appCategoryCode: ele.appCategoryCode,
            ipoCode: ele.ipoCode,
            amountToPay: ele.amountToPay,
            paymentMode: ele.paymentMode,
            paymentStatus: ele.paymentStatus,
            refundAmount: ele.refundAmount,
            brokerReco: ele.brokerReco,
            UPIId: ele.UPIId,
        }));
        return { status: true, message: null, data: data };
    } catch (error) {
        console.log(error);
        return { status: true, message: error, data: null };
    }

}

async function _getIpos(objIpoPayload) {

    // this function is used to show currentIPOData,futureIPOData,pastIPOData data
    //objIpoPayload ==> it is objectpayload which contain offername,offertype

    try {

        const objResp = await getIpoList(objIpoPayload);
        const currentIPOData = objResp?.data?.data?.CurrentIPOList;
        const futureIPOData = objResp?.data?.data?.FutureIPOList;
        const pastIPOData = objResp?.data?.data?.PastIPOList;

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { currentIPOData, futureIPOData, pastIPOData } };

    } catch (error) {

        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };

    }
}

//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
async function _getCmotsIpos(objIpoPayload) {
    try {

        const objRespCurrent = await getCmotsIpo({ ...objIpoPayload, type: 1 });
        const objRespFuture = await getCmotsIpo({ ...objIpoPayload, type: 2 });
        const objRespPast = await getCmotsIpo({ ...objIpoPayload, type: 3 });
        if (objRespCurrent?.data?.ResponseObject?.resultset?.length > 0) {
            var currentIPOData = objRespCurrent?.data?.ResponseObject?.resultset?.map(each => ({
                ...each,
                OfferName: each?.LName,
                bidStatus: IPO_TYPE.ONGOING,
                StartDate: each?.OpenDate,
                EndDate: each?.CloseDate,
                IPOCode: each?.CompanyCode,
            }));
        } else { }
        if (objRespFuture?.data?.ResponseObject?.resultset?.length > 0) {
            var futureIPOData = objRespFuture?.data?.ResponseObject?.resultset?.map(each => ({
                ...each,
                OfferName: each?.LName,
                bidStatus: IPO_TYPE.UPCOMING,
                StartDate: each?.OpenDate,
                EndDate: each?.CloseDate,
                IPOCode: each?.CompanyCode,
            }));
        } else { }
        if (objRespPast?.data?.ResponseObject?.resultset?.length > 0) {
            var pastIPOData = objRespPast?.data?.ResponseObject?.resultset?.map(each => ({
                ...each,
                OfferName: each?.LName,
                bidStatus: IPO_TYPE.PAST,
                StartDate: each?.OpenDate,
                EndDate: each?.CloseDate,
                IPOCode: each?.CompanyCode,
            }));
        } else { }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { currentIPOData, futureIPOData, pastIPOData } };

    } catch (error) {

        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };

    }
}
//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End





//Shuaib P : 21-10-2023  BT-110335-Breeze-IPO-Place Bid --start

function _placeQuickBid(strLotType, numLotSize, numMinPrice, numMaxPrice, MinOrderQty) {

    try {
        let objResp = {
            lot: '',
            price: '',
            amount: '',
            quantity: ''
        };

        if (strLotType === MIN_LOT) {
            objResp.lot = numLotSize === MinOrderQty ? MIN_LOT_VALUE : MinOrderQty;
            objResp.price = numMinPrice;
            objResp.quantity = objResp.lot * numLotSize;
            objResp.amount = objResp.quantity * numMinPrice;
        } else if (strLotType === MAX_LOT) {
            objResp.lot = MAX_LOT_VALUE;
            objResp.lot = MAX_LOT_VALUE;
            objResp.price = numMaxPrice;
            objResp.quantity = MAX_LOT_VALUE * numLotSize;
            objResp.amount = objResp.quantity * numMaxPrice;
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objResp };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

//Shuaib P : 21-10-2023  BT-110335-Breeze-IPO-Place Bid --end



// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --Start

function _calculateBid(lot, price, minPrice, maxPrice, lotSize, type, error, edit, bidNo) {
    try {
        let objResp = {
            lot: lot == 0 ? '' : +lot,
            price: price == 0 ? '' : +price,
            amount: +lot * lotSize * price,
            quantity: +lotSize * lot,
            error: error,
            lotError: error,
            edit: edit,
            bidNo: bidNo
        };
        if (type === 'lot') {
            if (!lot || +lot === 0) {
                objResp.lotError = true;
            } else {
                objResp.lotError = false;
            }
        }
        if (type === 'price') {
            if (price < minPrice || price > maxPrice) {
                objResp.error = true;
            } else {
                objResp.error = false;
            }
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objResp };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --End


// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --Start

function _calculateTotalPayableAmount(strBidType, arrBids) {
    try {
        let totalPayable = null;
        if (strBidType === QUICK_BID) {
            totalPayable = + arrBids[0]?.amount;
        } else {
            /*for (let i = 0; i < arrBids.length; i++) {
                totalPayable = totalPayable + arrBids[i]?.amount;
            }*/
            totalPayable = Math.max(...arrBids?.map(obj => obj?.amount));
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: totalPayable };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };

    }
}

// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --End




// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --Start

function _convertModifyBidData(arrBids, lotsize) {
    try {
        let bids = [];
        for (let i = 0; i < arrBids.length; i++) {
            let obj = {
                lot: 0,
                amount: 0,
                price: 0,
                error: false,
                lotError: false,
                edit: false,
                quantity: 0,
                bidNo: 0
            };
            obj['lot'] = +arrBids[i].lot;
            obj['quantity'] = +arrBids[i].quantity;
            obj['price'] = +arrBids[i].price;
            obj['amount'] = arrBids[i].price * lotsize * arrBids[i].lot;
            obj['bidNo'] = Number(arrBids[i].bidNo);
            bids.push(obj);
        }

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: bids };

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}


// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --End


// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --Start


function addHashToNumber(input) {
    const extractDigits = input.toString().slice(-6);
    return 'xxx' + extractDigits;
}

function _hashDefaultBankAccountNumber(arrBankDetails) {
    try {
        let strDefAccNo = null;
        let strNumberToHash;

        if (arrBankDetails.length > 1) {
            strNumberToHash = arrBankDetails.find((obj) => obj.is_default === true);
            strDefAccNo = addHashToNumber(strNumberToHash ? strNumberToHash?.account_no : arrBankDetails[0]?.account_no);
        } else if (arrBankDetails.length === 1) {
            strNumberToHash = arrBankDetails[0]?.account_no;
            strDefAccNo = addHashToNumber(strNumberToHash);
        }

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: strDefAccNo };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --End



// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --Start

async function _placeModifyBids(arrBids, objUserProfile, objModalData, strUpId) {
    try {
        let bids = [];
        //Vaibhav Singh:Added logic for handlig API call issues: Start
        let isModify = objModalData?.heading === "Modify Bid" ? true : false;
        let objPayload = {};
        //BREEZE: 3416 : IPO Responsive UI :ManasaB : 16-12-2024 : Changed payload for modification after discussion with Samadhan - Start
        if (arrBids.length === 1) {
            bids = [{
                "ActivityType": objModalData?.heading === "Modify Bid" ? 'M' : "N",
                "Cutoff": false,
                "Price": +arrBids[0]?.price,
                "BidNo": isModify ? (arrBids[0].bidNo == '' || arrBids[0].bidNo == null) ? '' : arrBids[0].bidNo : 0,
                "Qty": +arrBids[0]?.quantity

            }];
        } else if (arrBids.length > 1) {
            for (let i = 0; i < arrBids.length; i++) {
                bids.push({
                    "ActivityType": objModalData?.heading === "Modify Bid" ? 'M' : "N",
                    "Cutoff": false,
                    "Price": +arrBids[i]?.price,
                    "BidNo": isModify ? (arrBids[i].bidNo == '' || arrBids[i].bidNo == null) ? '' : arrBids[i]?.bidNo : 0,
                    "Qty": +arrBids[i]?.quantity
                });
            }
        }
        let strDpId = objUserProfile.dp_details.find((obj) => obj.clientBeneficiaryId === objModalData?.userDetails?.demat)?.dpId;
        let strBankAcc = objUserProfile.bank_details?.length !== 1 ? objUserProfile.bank_details.find((obj) => obj.is_default === true)?.account_no : objUserProfile.bank_details[0]?.account_no;

        objPayload = {
            "UserID": objUserProfile?.user_id,
            "GroupID": "HO",
            "UCCClientID": "",
            "UCCGroupID": "",
            "BidMode": objModalData?.heading === "Modify Bid" ? "M" : "N",
            "IPOCode": objModalData?.IPOCode,
            "Series": "EQ",
            "AppCategoryCode": CATEGORY_NAME[objModalData?.userDetails?.category],
            "DPId": strDpId,
            "BeneficiaryId": objModalData?.userDetails?.demat,
            "BankId": "",
          //  "BankAccountNo": isModify ? "" : strBankAcc,
            "BankAccountNo":  "" ,
            "TransactionNo": isModify ? Number(objModalData?.data?.transactionNo) : "",
            "ReferenceNo": isModify ? Number(objModalData?.data?.application_no) : "",
            "Bids": bids,
            "PaymentMode": "UPI",
            "UpiId": strUpId,
        };
        //Vaibhav Singh:Added logic for handlig API call issues: End
        let objResp = await getPlaceModifyBid(objPayload);

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objResp };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error?.response?.data };
    }
}

// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --End


// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --Start
function _bidsPriceValidation(arrBids) {
    try {
        for (let i = 1; i < arrBids.length; i++) {
            const currentBid = arrBids[i];
            const previousBid = arrBids[i - 1];

            if (currentBid.price <= previousBid.price) {
                return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error: `Bid ${i + 1} price should be greater than Bid ${i}` };
            }
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: 'Bids are valid' };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
// Shuaib P: 9/10/2023 : BT-110335 - Breeze-IPO-Place-Bid --End



export { _bidsPriceValidation, _placeModifyBids, _hashDefaultBankAccountNumber, _convertModifyBidData, _placeQuickBid, _getOrderBookDetails, _getIpos, _getCmotsIpos, _calculateBid, _calculateTotalPayableAmount }; 